module.exports = "/static/assets/8075fd8604b9a5ba15f5ff83abf61357.png";